/**
 * Definición de columnas para la tabla de listado de facturas.
 */
const tableColumns = [
  { Header: 'Factura', accessor: 'factura' },
  { Header: 'Fecha de Emisión', accessor: 'fecha' },
  { Header: 'Matrícula', accessor: 'matricula' },
  { Header: 'Cliente', accessor: 'cliente' },
  { Header: 'CIF Cliente', accessor: 'CIFCliente' },
  { Header: 'Alumno', accessor: 'alumno' },
  { Header: 'NIF Alumno', accessor: 'NIFAlumno' },
  { Header: 'Total Neto', accessor: 'TotalNeto' },
  { Header: 'Total Impuesto', accessor: 'TotalImpuesto' },
  { Header: 'Total Bruto', accessor: 'TotalBruto' },
  { Header: 'Descripción', accessor: 'descripcion' },
  { Header: 'Estado Recibos', accessor: 'Estadorecibos' },
  { Header: 'Estado Factura', accessor: 'EstadoFactura' },
  { Header: 'Centro', accessor: 'centro' },
  { Header: 'Plan', accessor: 'plan' },
  { Header: 'Grupo', accessor: 'Grupo' },
  { Header: 'Número abono', accessor: 'nabono' },
  { Header: 'Importe abono', accessor: 'iabono' },
  { Header: 'Fecha abono', accessor: 'fabono' },
];

export default tableColumns;
